import React from "react";
import { Helmet } from "react-helmet";

export const CriteoPixel = () => {
    return (
            <Helmet>
                <script type="text/javascript" src="//dynamic.criteo.com/js/ld/ld.js?a=58363" async="true"></script>
                <script>
                {`window.criteo_q = window.criteo_q || [];
var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
window.criteo_q.push(
    { event: "setAccount", account: 58363 },
    { event: "setEmail", email: "##Email Address##", hash_method: "##Hash Method##" },
    { event: "setSiteType", type: deviceType},
    { event: "setZipcode", zipcode: "##Zip Code##" },
    { event: "viewHome" });`}
                </script>
            </Helmet>
        );
}

export const CallCriteoOnAgreeAndContinue = () => {
    window.criteo_q.push({ event: "viewItem", item: "1" });
}

export const CallCriteoOnThankYouPage = (transactionId) => {
    window.criteo_q.push({ event: "trackTransaction", id: transactionId, 
        item: [{id: "1", price: "1", quantity: "1" }]});
}